module.exports = __webpack_public_path__ + "img/tools_Industry_club_group_customised_survey.531954ec.jpg";